var map = {
	"./tutorial_saba_1.png": 86620,
	"./tutorial_saba_2.png": 49727,
	"./tutorial_saba_3.png": 87331,
	"./tutorial_saba_4.png": 67070,
	"./tutorial_saba_5.png": 29784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41405;